"use strict";

import featureDetails from "./price-table.featureDetails";
import productActions from "./price-table.productActions";
import settingDetails from "./price-table.settingDetails";

export default {
    featureDetails,
    productActions,
    settingDetails,
};
